import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import {
  ViewBlocks,
  PageHeader,
  InfoBox,
  RelatedItems,
  RichText,
  PageMetadata,
} from 'iovisit-theme/components/Views';

const messages = defineMessages({
  timetable: { id: 'timetable', defaultMessage: 'Orari' },
  prices: { id: 'prices', defaultMessage: 'Prezzi' },
  possible_destinations: {
    id: 'Possible destinations',
    defaultMessage: 'Dove posso andare da qui?',
  },
  to_visit_nearby: {
    id: 'To visit nearby',
    defaultMessage: 'Cosa vedere nelle vicinanze',
  },
});
const PointOfInterestView = ({ content, location }) => {
  const intl = useIntl();

  const timetable = RichText({
    content: content.timetable,
    title: intl.formatMessage(messages.timetable),
    titleTag: 'h3',
  });

  const prices = RichText({
    content: content.prices,
    title: intl.formatMessage(messages.prices),
    titleTag: 'h3',
  });

  return (
    <div id="page-point-of-interest" className="ui container">
      <PageHeader content={{ ...content, show_share_links: true }} />
      {(timetable || prices) && (
        <InfoBox>
          {timetable} {prices}
        </InfoBox>
      )}

      <ViewBlocks content={content} location={location} />

      <RelatedItems
        title={intl.formatMessage(messages.possible_destinations)}
        items={content.possible_destinations}
        background={true}
      />
      <RelatedItems
        title={intl.formatMessage(messages.to_visit_nearby)}
        items={content.to_visit_nearby}
        background={
          !content.possible_destinations ||
          content.possible_destinations?.length === 0
        }
      />

      <PageMetadata content={{ ...content, show_modified: true }} />
    </div>
  );
};

export default PointOfInterestView;
